import client from '../../utils/client';
import services from '../../utils/services';

export async function loginApi(data) {
  return client.post(services.authenticateUser, data);
}
